import React from 'react';
import { Card } from '../ui/card';
import { Trophy, Medal, Download } from 'lucide-react';

export const LeaderboardTab = ({ leaderboard }) => {
  if (!leaderboard) return null;

  return (
    <Card className="p-6  bg-[var(--isp-glass)] backdrop-blur-xl border-[var(--isp-glass-border)]" data-testid="campus-leaderboard">
      <h3 className="text-lg font-semibold text-[var(--isp-heading)] mb-4 flex items-center gap-2">
        <Trophy className="w-5 h-5 text-amber-400" />
        Campus Leaderboard
      </h3>
      {leaderboard.leaderboard.length === 0 && (
        <p className="text-[var(--isp-body)] text-center py-8">No members with activity yet</p>
      )}
      {leaderboard.leaderboard.length > 0 && (
        <div className="space-y-2">
          {leaderboard.leaderboard.map((entry, i) => {
            const rowCls = entry.is_you
              ? 'bg-purple-500/10 border border-purple-500/20'
              : 'bg-slate-800/30 border border-[var(--isp-glass-border)]';
            const rankCls = entry.rank <= 3
              ? 'bg-amber-500/20 text-amber-300'
              : 'bg-[var(--isp-glass-inner)] text-[var(--isp-body)]';
            return (
              <div
                key={entry.user_id || `lb-${i}`}
                className={`flex items-center gap-3 p-3 rounded-xl ${rowCls}`}
                data-testid={`lb-entry-${i}`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm ${rankCls}`}>
                  {entry.rank <= 3 ? <Medal className="w-4 h-4" /> : `#${entry.rank}`}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-[var(--isp-heading)] truncate">
                    {entry.name} {entry.is_you && <span className="text-xs text-purple-400">(You)</span>}
                  </p>
                  <p className="text-xs text-[var(--isp-muted)]">
                    {entry.exams_taken} exams | Avg {entry.avg_exam_score}% | {entry.badges} badges
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-amber-400">{entry.xp}</p>
                  <p className="text-[10px] text-[var(--isp-muted)]">XP</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
};

export const ReportsTab = ({ onExport }) => (
  <Card className="p-6  bg-[var(--isp-glass)] backdrop-blur-xl border-[var(--isp-glass-border)]" data-testid="campus-reports">
    <h3 className="text-lg font-semibold text-[var(--isp-heading)] mb-4 flex items-center gap-2">
      <Download className="w-5 h-5 text-green-400" />
      Usage Reports
    </h3>
    <p className="text-sm text-[var(--isp-body)] mb-6">Download detailed usage reports for your campus members</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <button
        onClick={() => onExport('csv')}
        className="p-6 rounded-xl bg-[var(--isp-glass)] backdrop-blur-xl border border-[var(--isp-glass-border)] hover:border-green-500/30 hover:bg-green-500/5 transition-all text-left"
        data-testid="export-csv-btn"
      >
        <Download className="w-8 h-8 text-green-400 mb-3" />
        <p className="font-medium text-white">CSV Report</p>
        <p className="text-xs text-[var(--isp-body)] mt-1">Spreadsheet-ready format with member activity data</p>
      </button>
      <button
        onClick={() => onExport('json')}
        className="p-6 rounded-xl bg-[var(--isp-glass)] backdrop-blur-xl border border-[var(--isp-glass-border)] hover:border-blue-500/30 hover:bg-blue-500/5 transition-all text-left"
        data-testid="export-json-btn"
      >
        <Download className="w-8 h-8 text-blue-400 mb-3" />
        <p className="font-medium text-white">JSON Report</p>
        <p className="text-xs text-[var(--isp-body)] mt-1">Machine-readable format for custom integrations</p>
      </button>
    </div>
  </Card>
);
